import { eProductFilterGroupType } from "./eProductFilterGroupType";
import { eProductFilterType } from "./eProductFilterItemType";
import { Params } from '@angular/router';

export class ProductFilter {
	/**
	 * Esto es el id de las cosas. No value
	 */
	id! : number;
	title! : string;
	type! : eProductFilterType;
	group_id! : eProductFilterGroupType;
	value! : number;
	extra! : any[];

	constructor(id:number, group_id:eProductFilterGroupType, type:eProductFilterType, title?:string, min?:number, max?:number) {
		this.id = id;
		this.group_id = group_id;
		this.type = type;
		if (title)
			this.title = title;
		if (min && max) {
			this.extra = [
				{
					min: min,
					max: max
				}
			]
		}
	}
}

export function productFilterToQueryParameter(pf:ProductFilter, min?:number, max?:number) : Params {
	switch(pf.group_id) {
		case eProductFilterGroupType.CATEGORIES : {
			return {c: pf.id};
		}
		case eProductFilterGroupType.DISCOUNTS : {
			return {d: min+","+max}
		}
		case eProductFilterGroupType.PRICES : {
			return {p: min+","+max}
		}
		case eProductFilterGroupType.SHIPPING : {
			return {g: true}
		}
		case eProductFilterGroupType.VALUABLES : {
			return {v: pf.id}
		}
		default : {
			return {}
		}
	}
}

export function productFilterToQPKey(pf:ProductFilter) {
	switch(pf.group_id) {
		case eProductFilterGroupType.CATEGORIES : {
			return "c";
		}
		case eProductFilterGroupType.DISCOUNTS : {
			return "d";
		}
		case eProductFilterGroupType.PRICES : {
			return "p";
		}
		case eProductFilterGroupType.SHIPPING : {
			return "g"
		}
		case eProductFilterGroupType.VALUABLES : {
			return "v"
		}
		default : {
			return ""
		}
	}
}